function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4caf50",
  d: "M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc107",
  d: "M24,4v20l8,4l-8.843,16c0.317,0,0.526,0,0.843,0c11.053,0,20-8.947,20-20S35.053,4,24,4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4caf50",
  d: "M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc107",
  d: "M24,4v20l8,4l-8.843,16c0.317,0,0.526,0,0.843,0c11.053,0,20-8.947,20-20S35.053,4,24,4z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f44336",
  d: "M41.84,15H24v13l-3-1L7.16,13.26H7.14C10.68,7.69,16.91,4,24,4C31.8,4,38.55,8.48,41.84,15z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#dd2c00",
  d: "M7.158,13.264l8.843,14.862L21,27L7.158,13.264z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#558b2f",
  d: "M23.157,44l8.934-16.059L28,25L23.157,44z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f9a825",
  d: "M41.865,15H24l-1.579,4.58L41.865,15z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M33,24c0,4.969-4.031,9-9,9s-9-4.031-9-9s4.031-9,9-9S33,19.031,33,24z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#2196f3",
  d: "M31,24c0,3.867-3.133,7-7,7s-7-3.133-7-7s3.133-7,7-7S31,20.133,31,24z"
});

var SvgIcons8Chrome = function SvgIcons8Chrome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8Chrome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-chrome.cb2cac12.svg";
export { ForwardRef as ReactComponent };